import { CourseMaterial } from "./coursesLoader.ts";
import useVirtualStore from "./useVirtualStore.tsx";
import useStoreProduct from "./useStoreProduct.tsx";

export default function useStudentChoice(material: CourseMaterial) {
  const { isVirtualStore } = useVirtualStore();
  const { isOutOfStock } = useStoreProduct(material);
  const isMinPDPActive =
    isVirtualStore &&
    material.buttonLinks.find((link) => link.type === "ePOS") &&
    !isOutOfStock;
  return { isMinPDPActive, isMaterialOutOfStock: isOutOfStock };
}
